export interface RTCInboundRtpVideoStreamStats extends RTCInboundRtpStreamStats {
    kind: 'video';
    bytesReceived: number;
    framesReceived?: number;
    framesPerSecond: number;
    frameWidth: number;
}

export function isRTCInboundRtpStreamStats(x: RTCStats): x is RTCInboundRtpStreamStats {
    return x.type === 'inbound-rtp';
}

export function isRTCInboundRtpVideoStreamStats(x: RTCStats): x is RTCInboundRtpVideoStreamStats {
    return isRTCInboundRtpStreamStats(x) && x.kind === 'video';
}
